module.exports = __webpack_public_path__ + "img/1723433826023-image.jpg.e88664cc.webp";